import Image from "components/Image"
import richText from "utilities/richText"

export default function PhotoCard({ blok }) {
  return (
    <div className="mx-auto my-10 max-w-xl rounded-10 bg-stone-mid prose-img:m-0 lg:flex lg:max-w-none">
      <div className="lg:max-w-[325px]">
        <Image
          alt={blok.image.alt}
          src={blok.image.filename}
          height={300}
          width={600}
          className="h-full rounded-10 shadow"
          style={{ objectFit: "cover" }}
        />
      </div>
      <div className="p-7 xl:pl-12">
        <div className="photo-card prose max-w-none prose-h2:mb-2 prose-h2:text-evergreen-mid prose-p:m-0 prose-ul:mb-1">
          {richText(blok.content)}
        </div>
      </div>
    </div>
  )
}
